<template>
<div class="chapter">
<div class="inner_page">
<p class="p5"><b>Contents</b></p>
<p class="tcd"><a href="#/section3">Can You Feel Anything When I Do This?</a></p>
<p class="tcd"><a href="#/section4">Cordle to Onion to Carrot</a></p>
<p class="tcd"><span href="#/section5" title="Link target outside of Sample">The Petrified World</span></p>
<p class="tcd"><span href="#/section6" title="Link target outside of Sample">Game – First Schematic</span></p>
<p class="tcd"><span href="#/section7" title="Link target outside of Sample">Doctor Zombie and His Little Furry Friends</span></p>
<p class="tcd"><span href="#/section8" title="Link target outside of Sample">The Cruel Equations</span></p>
<p class="tcd"><span href="#/section9" title="Link target outside of Sample">The Same to You Doubled</span></p>
<p class="tcd"><span href="#/section10" title="Link target outside of Sample">Starting from Scratch</span></p>
<p class="tcd"><span href="#/section11" title="Link target outside of Sample">The Mnemone</span></p>
<p class="tcd"><span href="#/section12" title="Link target outside of Sample">Tripout</span></p>
<p class="tcd"><span href="#/section13" title="Link target outside of Sample">Notes on the Perception of Imaginary Differences</span></p>
<p class="tcd"><span href="#/section14" title="Link target outside of Sample">Down the Digestive Tract and Into the Cosmos with Mantra, Tantra, and Specklebang</span></p>
<p class="tcd"><span href="#/section15" title="Link target outside of Sample">Pas de Trois of the Chef and the Waiter and the Customer</span></p>
<p class="tcd"><span href="#/section16" title="Link target outside of Sample">Aspects of Langranak</span></p>
<p class="tcd"><span href="#/section17" title="Link target outside of Sample">Plague Circuit</span></p>
<p class="tcd"><span href="#/section18" title="Link target outside of Sample">Tailpipe to Disaster</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?33f58a5d